import { TableColumn } from './types';

export const getStickyOffsets = (columns: TableColumn[]): Map<string, number> => {
  const offsets = new Map<string, number>();
  let cumulativeLeft = 0;
  for (const column of columns) {
    if (!column.sticky) break;
    offsets.set(column.key, cumulativeLeft);
    cumulativeLeft += column.width;
  }
  return offsets;
};
